import { ButtonProps, TagProps } from 'spindl-shared-components';
import { PopperProps } from './types';

type CellCalendarModalInternalProps = {
  tag?: TagProps;
  doneButton?: ButtonProps;
  cancelButton?: ButtonProps;
  clearButton?: ButtonProps;
  popperProps?: PopperProps;
};

type CellCalendarModalPropsValues = {
  '': CellCalendarModalInternalProps;
};

const propValues: CellCalendarModalPropsValues = {
  '': {
    doneButton: {
      type: 'Text',
      size: 'M',
      styleType: 'Primary',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
    clearButton: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
    popperProps: {
      popperModifiers: [
        {
          name: 'offset',
          options: {
            offset: [44, -12],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            rootBoundary: 'viewport',
            tether: false,
            altAxis: true,
          },
        },
      ],
      popperPlacement: 'bottom',
    },
  },
};

const getProps = (type: string): CellCalendarModalInternalProps => {
  const values: CellCalendarModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
